import React, { useContext } from 'react';
import _ from 'lodash';
import StatsLeaders from './Leaders/StatsLeaders';
import { usePlayersStats } from '../../hooks/playerStats';
import { useTeamsStats } from '../../hooks/teamStats';
import { getLeadersWithTopListNumber } from '../../hooks/leaders';
import { DataContext } from '../../context/data-context';

function Overview({ show }) {
  const { currentSeason } = useContext(DataContext);

  const [playersStats, playersStatsLoading, playersStatsError] =
    usePlayersStats(currentSeason);

  const [teamsStats, teamsStatsLoading, teamsStatsError] =
    useTeamsStats(currentSeason);

  if (!show) return null;
  // eslint-disable-next-line no-restricted-globals
  history.pushState({ urlPath: '/statistik' }, '', '/statistik');

  const toRenderPlayer =
    !playersStats || playersStatsLoading || playersStatsError
      ? []
      : [
        {
          data: getLeadersWithTopListNumber(
            playersStats?.map((x) => ({ ...x, stat: x.goals }))
          ).splice(0, 10),
          type: 'goals',
          title: 'Mål',
        },
        {
          data: getLeadersWithTopListNumber(
            playersStats?.map((x) => ({ ...x, stat: x.assists }))
          ).splice(0, 10),
          type: 'assists',
          title: 'Assist',
        },
        {
          data: getLeadersWithTopListNumber(
            playersStats?.map((x) => ({ ...x, stat: x.yellowCards }))
          ).splice(0, 10),
          type: 'yellowCards',
          title: 'Gula kort',
        },
        {
          data: getLeadersWithTopListNumber(
            playersStats?.map((x) => ({ ...x, stat: x.highestSpeed }))
          ).splice(0, 10),

          type: 'highestSpeed',
          title: 'Högsta hastighet',
        },
      ];

  const toRenderTeam =
    !teamsStats || teamsStatsLoading || teamsStatsError
      ? []
      : [
        {
          data: getLeadersWithTopListNumber(
            teamsStats?.map((x) => ({ ...x, stat: x.goals }))
          ).splice(0, 10),
          type: 'goals',
          title: 'Mål',
        },
        {
          data: getLeadersWithTopListNumber(
            teamsStats?.map((x) => ({ ...x, stat: x.setPieceGoals }))
          ).splice(0, 10),
          type: 'setPieceGoals',
          title: 'Mål på fasta situationer',
        },
        {
          data: getLeadersWithTopListNumber(
            teamsStats?.map((x) => ({ ...x, stat: x.averagePossesion }))
          ).splice(0, 10),
          type: 'averagePossesion',
          title: 'Genomsnitt bollinnehav',
        },
        {
          data: getLeadersWithTopListNumber(
            teamsStats?.map((x) => ({
              ...x,
              stat: _.round(x.totalDistance / 1000, 0),
            }))
          ).splice(0, 10),
          type: 'totalDistance',
          title: 'Löpmeter (km)',
        },
        {
          data: getLeadersWithTopListNumber(
            teamsStats?.map((x) => ({ ...x, stat: x.yellowCards }))
          ).splice(0, 10),
          type: 'yellowCards',
          title: 'Gula kort',
        },
        {
          data: getLeadersWithTopListNumber(
            teamsStats?.map((x) => ({ ...x, stat: x.shotsOnTarget }))
          ).splice(0, 10),
          type: 'shotsOnTarget',
          title: 'Skott på mål',
        },
      ];

  return (
    <>
      <h2 className="heading-h6 heading-lg-h3 my-3 my-lg-4">SPELARE</h2>
      <div className="overflow-x-auto d-flex flex-nowrap row">
        {toRenderPlayer.map((d) => (
          <div
            key={`${d.type}`}
            className="scrollable-content-width col-4 mb-3 ms-2 ms-lg-0 me-3 me-ls-0 me-lg-0 px-0 px-lg-2"
          >
            <div className="data-container">
              <div className="px-4 pt-4">
                <h5 className="heading-h5">{d.title}</h5>
              </div>

              <StatsLeaders type={d.type} data={d.data} />
            </div>
          </div>
        ))}
      </div>
      <h2 className="heading-h6 heading-lg-h3 my-3 my-lg-4">LAG</h2>
      <div className="overflow-x-auto d-flex flex-nowrap row">
        {toRenderTeam.map((d) => (
          <div
            key={`${d.type}`}
            className="scrollable-content-width col-4 mb-3 ms-2 ms-lg-0 me-3 me-ls-0 me-lg-0 px-0 px-lg-2"
          >
            <div className="data-container">
              <div className="px-4 pt-4">
                <h5 className="heading-h5">{d.title}</h5>
              </div>

              <StatsLeaders type={`teams_${d.type}`} data={d.data} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Overview;
